import { createStyles, rem } from '@mantine/core'

export interface StylesParams {
  bgColor?: string
  productNumber: number
}

export default createStyles(
  (theme, { bgColor, productNumber }: StylesParams) => {
    return {
      root: {
        backgroundColor: bgColor || theme.colors.blue[0],
        paddingTop: rem(80),
        paddingBottom: rem(80),
        [theme.fn.smallerThan('sm')]: {
          paddingTop: rem(32),
          paddingBottom: rem(32),
        },
      },
      inner: {
        display: 'flex',
        flexDirection: 'column',
        gap: rem(16),
        [theme.fn.largerThan('sm')]: {
          gap: rem(40),
        },
      },
      heading: {
        color: '#fff',
      },
      widgets: {
        [theme.fn.largerThan('sm')]: {
          ...(productNumber === 1
            ? {
                background: '#fff',
              }
            : {
                padding: 0,
                background: 'transparent',
              }),
        },
        [theme.fn.smallerThan('sm')]: {
          background: 'transparent',
          margin: '0 -16px',
        },
      },
      cardRoot: {
        [theme.fn.largerThan('sm')]: {
          ...(productNumber === 2
            ? {
                padding: rem(16),
              }
            : {}),
        },
      },
      cardThumbnail: {
        [theme.fn.largerThan('sm')]: {
          ...(productNumber === 2
            ? {
                width: rem(164),
              }
            : {}),
        },
      },
      progressBar: {},
      progressRoot: {
        background: `rgba(255,255,255,0.5)`,
      },
    }
  },
)
